import { render, staticRenderFns } from "./kushof.vue?vue&type=template&id=367c135a&"
import script from "./kushof.vue?vue&type=script&lang=js&"
export * from "./kushof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports